import { Card, Image, Text } from "@mantine/core";
import { useState } from "react";
import { useAppSelector } from "src/redux/redux-store/hooks";
import Icon from "./common/Icons/Icons/Icon";

const UserMessage = (props: { message: string, traceless?: boolean }) => {
  const user = useAppSelector((state) => state.user)
  const [imageError, setImageError] = useState(false)

  // Custom JSON validation for file/image messages
  const isFileOrImageJSON = (str: string): boolean => {
    try {
      const parsed = JSON.parse(str);
      return parsed && typeof parsed === 'object' &&
             ('file_name' in parsed || 'image_url' in parsed || 'content_type' in parsed);
    } catch (e) {
      return false;
    }
  };

  const isJSONMessage = typeof props.message === 'string' &&
  (props.message.startsWith('{') || props.message.startsWith('[')) &&
  isFileOrImageJSON(props.message);


  if (isJSONMessage) {
    const formattedMessage = JSON.parse(props.message)

    if (formattedMessage.image_url) {    //Image Message
      // Handle both array and string formats for image_url
      const imageUrl = Array.isArray(formattedMessage.image_url)
        ? formattedMessage.image_url[0]
        : formattedMessage.image_url;

      return (
        <div className="flex flex-col items-end justify-start pt-0 mq800:max-w-full">
          <div className={`flex flex-row gap-4 items-center justify-end`}>
          {!imageError ? <div className="rounded-lg border w-1/2 bg-primary p-1"><Image
            radius={10}
            onError={() => setImageError(true)}
            src={imageUrl}
          />  </div> : <Card className=" flex justify-center gap-2 items-center rounded-lg bg-primary py-3 px-8" withBorder >
            <Icon size="15" color="white" name="image" /><Text className="text-white font-semibold">{formattedMessage.file_name}</Text>
          </Card>}
          <div className="w-10 h-10 overflow-hidden rounded-full border border-gray-300 flex items-center justify-center">
            <img
              src={user.profile_picture_url ? user.profile_picture_url : '/images/user-avatar.png'}
              alt="User avatar"
              className="w-10 h-10 rounded-full object-cover"
            />

       </div>
          </div>
        </div>
      )
    } else {
      return (    //Document Message
      <div className=" flex flex-col items-end justify-start pt-0 mq800:max-w-full">
          <div className={`flex flex-row gap-4 items-center`}>
         <Card className=" flex justify-center bg-primary py-3 px-8 items-center rounded-lg gap-2" withBorder >
            <Icon size="15" color="white" name="file" /><Text  className="text-white font-semibold">{formattedMessage.file_name}</Text>
          </Card>
          <div className="w-10 h-10 overflow-hidden rounded-full border border-gray-300 flex items-center justify-center">
            <img
              src={user.profile_picture_url ? user.profile_picture_url : '/images/user-avatar.png'}
              alt="User avatar"
              className="w-10 h-10 rounded-full object-cover"
            />

       </div>
          </div>
        </div>
      )
    }

  }

  return (
    <div className=" flex flex-col items-end justify-start mq800:max-w-full">
      <div className={`flex flex-row gap-4 items-center`}>
          <div className={`relative rounded-lg bg-primary py-3 px-8 text-md leading-[22px] text-left font-semibold text-white inline-block max-w-[400px]`}>
            {props.message}
          </div>
          
          <div className="w-10 h-10 overflow-hidden rounded-full border border-gray-300 flex items-center justify-center">
            <img
              src={user.profile_picture_url ? user.profile_picture_url : '/images/user-avatar.png'}
              alt="User avatar"
              className="w-10 h-10 rounded-full object-cover"
            />

       </div>
      </div>
    </div>
  );
};

export default UserMessage;